<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import FooterDesktopFrame from "@/assets/footer_frame_desktop.png";
import FooterMobileFrame from "@/assets/footer_frame_mobile.png";
import { getMemberId, getUserId } from "./utils/uniqueIdManager";

export default {
  name: "App",
  components: {},
  data() {
    return {
      FooterDesktopFrame,
      FooterMobileFrame,
    };
  },
  created() {
    this.$root.userId = getUserId();
  },
};
</script>

<style scoped>
body {
  font-family: "Noto Sans JP", sans-serif;
}

.v-application {
  font-family: "Noto Sans JP", sans-serif !important;
}
.v-main {
  padding: 0 !important;
}
</style>
